export class DatePicker extends HTMLElement {
  datePickerSelect = this.querySelector('[date-picker]');
  timePickerSelects = this.querySelectorAll('[time-picker]');

  async connectedCallback() {
    this.datePickerSelect?.addEventListener('change', (event) => {
      const value = event.target.value;
      this.timePickerSelects.forEach((timePickerSelect) => {
        if (timePickerSelect.getAttribute('time-picker') == value) {
          timePickerSelect.parentElement.style.display = '';
        } else {
          timePickerSelect.parentElement.style.display = 'none';
        }
      });
    });
  }
}
if (!customElements.get('shop-date-picker')) {
  customElements.define('shop-date-picker', DatePicker);
}
